/**
 * 检查用户是否登录
 * @param {Object} route - 路由对象
 * @returns {boolean} - 是否登录
 */
const checkLogin = (route) => {
  const userStore = useUserStore()
  if (!userStore.token) {
    let obj = {}
    obj = {
      path: '/login',
      query: {
        redirect: route.fullPath
      }
    }
    toRouter(obj)
    return false
  } else {
    return true
  }
}

export default checkLogin
